var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "#333333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68162 0.289241L7.80041 3.70443C7.90616 3.82055 7.97309 3.96125 7.99343 4.11018C8.01377 4.25911 7.98668 4.41018 7.91531 4.54583C7.84394 4.68149 7.73122 4.79616 7.59022 4.87656C7.44923 4.95695 7.28576 4.99975 7.11879 5H0.881214C0.714238 4.99975 0.550766 4.95695 0.409776 4.87656C0.268786 4.79616 0.156063 4.68149 0.084693 4.54583C0.0133232 4.41018 -0.0137656 4.25911 0.00657257 4.11018C0.0269107 3.96125 0.0938411 3.82055 0.199593 3.70443L3.31838 0.289241C3.40119 0.198798 3.50525 0.125956 3.6231 0.0759463C3.74096 0.0259366 3.86967 0 4 0C4.13033 0 4.25905 0.0259366 4.3769 0.0759463C4.49475 0.125956 4.59882 0.198798 4.68162 0.289241Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.c91304050e4e5b7f94175c730c8b0178.svg";
export { ForwardRef as ReactComponent };